import { h, Component } from 'preact';
import s from 'components/shared/social/messengerButton.sss';
import Store from 'store/store';
import * as actions from 'store/actions';
import { track } from 'utils/tracking';
import { addClass, joinClasses } from 'utils/utils';
import HTML from 'components/core/html/html';

// WARNING: data-ref must be "a string of less than 150 characters. Allowed characters include alphanumeric characters and +-./:=_" (facebook restriction)
// And it's the only thing we can use to send infos to our backend
// (at the moment we use [appId]:t:lat:lon, with :lat:lon optional, and t meaning tickets but irrelevant now)
export default class MessengerButton extends Component {

	constructor({ fbPageId }) {
		super();

		this.iframe = null;
		this.custom = true; // TODO: this as a prop ? Toggles between the default facebook look and our hijack.
		this.loaded = false;

		this.storageKey = 'powster_messengerButton_' + fbPageId;
		this.iframeMouseOver = false;
	}

	fbReady() {
		if (!window.FB) {
			return;
		}

		// TODO: clean this
		this.onFbRender = () => {
			if (!this.base) return;
			// FB parsed the DOM and is ready
			const frame = this.base.querySelector('iframe');
			if (frame) { // Should be always true but just in case
				this.iframe = frame;

				frame.addEventListener('load', () => this.iframeLoaded());
				frame.addEventListener('mouseover', () => (this.iframeMouseOver = true));
				frame.addEventListener('mouseout', () => (this.iframeMouseOver = false));
			} else {
				this.iframeLoaded();
			}
			// ensure window is focused on load to make blur on click work correctly
			window.focus();
		};

		window.FB.Event.subscribe('xfbml.render', this.onFbRender);
		window.addEventListener('blur', () => {
			if (this.iframeMouseOver) {
				this.$reminderText.innerHTML = this.props.copy.$MESSENGER_SENT;
				window.localStorage.setItem(this.storageKey, this.props.copy.$MESSENGER_SENT);
				Store.emit(actions.MESSENGER_CLICKED);
				track({ a: this.props.trackId || 'messenger-clicked' });
			}
		});
		window.FB.XFBML.parse();
	}

	componentDidMount() {
		let { fbAppId, fbPageId } = this.props;
		if (!fbAppId || !fbPageId) return;
		if (typeof window !== 'undefined' && !window.FB) {
			window.fbAsyncInit = () => {
				window.FB.init({
					appId:   fbAppId,
					xfbml:   true,
					version: 'v2.6'
				});
				this.fbReady();
			};
			(function(d, s, id) {
				const fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) return;
				const js = d.createElement(s);
				js.id = id;
				js.src = '//connect.facebook.net/en_US/sdk.js';
				fjs.parentNode.insertBefore(js, fjs);
			})(document, 'script', 'facebook-jssdk');
		} else if (typeof window !== 'undefined') {
			this.fbReady();
		}
		this.getLocalStorageCopy();
	}

	shouldComponentUpdate({ geo }) {
		return geo !== this.props.geo;
	}

	componentWillUnmount() {
		if (typeof window !== 'undefined' && window.FB) {
			window.FB.Event.unsubscribe('xfbml.render', this.onFbRender);
		}
		if (this.$button) {
			this.$button.removeAttribute('fb-xfbml-state');
			this.$button.removeAttribute('fb-iframe-plugin-query');
		}
	}

	iframeLoaded() {
		this.loaded = true;
		if (this.base) {
			addClass(this.base, s.loaded);
		}
	}

	getLocalStorageCopy() {
		if (typeof window !== 'undefined') {
			const messengerCopy = window.localStorage.getItem(this.storageKey);
			this.setState({ storedMessengerButtonCopy : messengerCopy });
		}
	}

	getRefData() {
		// let full = this.props.appId + ':' + (this.props.eventType || 't');
		// const loc = this.props.geo;
		// if (loc) {
		// 	full += ':' + loc.lat.toFixed(3) + ':' + loc.lon.toFixed(3);
		// }
		// return full;
		let props = this.props;
		if (props.entryPoint && !props.fbRef) {
			return '/goto:' + props.entryPoint;
		}
		return props.fbRef || '';
	}

	render({ copy, appId, fbPageId, fbAppId, eventType, ...props }) {
		if (!fbAppId || !fbPageId) {
			return <div key="messenger" />;
		}
		const refData = this.getRefData();
		const classes = joinClasses(
			s.wrapper,
			this.custom && s.custom,
			this.loaded && s.loaded,
			props.class
		);

		let bubble = null;
		if (!props.noBubble && copy.$MESSENGER_DESCRIPTION) {
			bubble = <HTML class={joinClasses(s.speechBubble, props.bubbleClass)} content={copy.$MESSENGER_DESCRIPTION} markdown />;
		}

		const reminderText = this.state.storedMessengerButtonCopy || copy.$MESSENGER_REMINDER;

		return (
			<div class={joinClasses(s.contentWrapper, props.outerClass)} key="messenger">
				{bubble}
				<div class={classes} key="content">
					<div
						class={joinClasses('fb-send-to-messenger', s.button)}
						ref={$ref => this.$button = $ref}
						messenger_app_id={fbAppId}
						page_id={fbPageId}
						data-ref={refData}
						color="blue"
						size="standard"
						key="rendered"
					/>
					<div class={joinClasses(s.cta, props.innerClass)} key="cta">
						{!props.noIcon && <div class={s.iconBox}><div class={s.icon} /></div>}
						<span ref={$ref => this.$reminderText = $ref}>
							{reminderText}
						</span>
					</div>
				</div>
			</div>
		);
	}

}
